// product-scroller.js — full-width viewport, 1-up mobile / 3-up desktop
// INFINITE LOOP VERSION – seamless checkers, looped track, drag + arrows + throttled nav
(function () {
  const SEL = '.product-scroller';
  const MOBILE = 880; // <880 => 1 item; >=880 => 3 items
  const perViewFor = (w) => (w < MOBILE ? 1 : 3);

  function setupSection(root) {
    const viewport = root.querySelector('.ps-viewport');
    const track = root.querySelector('.ps-track');
    const prev = root.querySelector('.ps-nav--prev');
    const next = root.querySelector('.ps-nav--next');

    if (!viewport || !track) return;

    const baseChecker = parseFloat(root.dataset.checkerSize || '28');
    root.style.setProperty('--checker', baseChecker + 'px');

    // Original cards only (no clones)
    let baseCards = Array.from(track.querySelectorAll('.ps-card'));
    let cards = baseCards.slice(); // current cards in DOM (incl. clones)
    let baseLen = baseCards.length;
    let perView = 3;
    let colW = 0;

    // Which REAL card we're on (0..baseLen-1)
    let logicalIndex = 0;

    // How many clones on each side
    let cloneCount = 0;

    // Actual index into `cards` (inc. clones)
    let index = 0;

    // Prevent spam-clicking during slide
    let isAnimating = false;

    if (!baseLen) return;

    const maxIndexFor = () => Math.max(0, cards.length - perView);

    function updateButtons() {
      // Infinite loop: buttons are always enabled
      if (prev) prev.removeAttribute('disabled');
      if (next) next.removeAttribute('disabled');
    }

    function buildClones() {
      // Remove any existing clones
      track.querySelectorAll('.ps-card.is-clone').forEach((el) => el.remove());

      // Ensure baseCards is up to date (real cards only)
      baseCards = Array.from(track.querySelectorAll('.ps-card')).filter(
        (el) => !el.classList.contains('is-clone')
      );
      baseLen = baseCards.length;
      if (!baseLen) return;

      const vpW = viewport.clientWidth || root.clientWidth || window.innerWidth;
      perView = perViewFor(vpW);

      cloneCount = Math.min(baseLen, perView); // at least enough to fill a view

      const fragStart = document.createDocumentFragment();
      const fragEnd = document.createDocumentFragment();

      const len = baseCards.length;

      // Prepend last `cloneCount` cards
      for (let i = 0; i < cloneCount; i++) {
        const srcEnd = baseCards[len - cloneCount + i];
        if (srcEnd) {
          const cloneEnd = srcEnd.cloneNode(true);
          cloneEnd.classList.add('is-clone');
          fragStart.appendChild(cloneEnd);
        }
      }

      // Append first `cloneCount` cards
      for (let i = 0; i < cloneCount; i++) {
        const srcStart = baseCards[i];
        if (srcStart) {
          const cloneStart = srcStart.cloneNode(true);
          cloneStart.classList.add('is-clone');
          fragEnd.appendChild(cloneStart);
        }
      }

      track.insertBefore(fragStart, track.firstChild);
      track.appendChild(fragEnd);

      cards = Array.from(track.querySelectorAll('.ps-card'));
    }

    function applyWidths() {
      const vpW = viewport.clientWidth || root.clientWidth || window.innerWidth;
      perView = perViewFor(vpW);
      colW = vpW / perView || 0;

      const minSquares = 4;
      const approxSquares = Math.max(minSquares, Math.round(colW / baseChecker));
      const effChecker = colW / approxSquares;
      root.style.setProperty('--checker-eff', effChecker + 'px');

      cards.forEach((card) => card.style.setProperty('--col-w', colW + 'px'));
      track.style.width = colW * cards.length + 'px';
    }

    function instantTo(i) {
      index = i;
      track.style.transition = 'none';
      track.style.transform = 'translateX(' + -index * colW + 'px)';
      // force reflow so the browser applies transform before re-enabling transition
      void track.offsetHeight;
      track.style.transition = '';
      updateButtons();
    }

function animateTo(i) {
  if (isAnimating || !colW) return;

  isAnimating = true;
  root.classList.add('ps--scrolling');

  index = i;
  track.style.transform = 'translateX(' + -index * colW + 'px)';

  updateButtons();

  // Throttle
  setTimeout(() => {
    isAnimating = false;
    root.classList.remove('ps--scrolling');
  }, 300);
}

    function layout() {
      if (!baseLen) return;

      buildClones();
      cards = Array.from(track.querySelectorAll('.ps-card'));
      if (!cards.length) return;

      applyWidths();

      // Keep current logical card centred after resize
      const firstRealIndex = cloneCount + logicalIndex;
      const maxIdx = maxIndexFor();
      const safeIndex = Math.max(0, Math.min(maxIdx, firstRealIndex));

      instantTo(safeIndex);
    }

    function go(delta) {
      if (!baseLen) return;

      // Move "virtual" index in real cards
      logicalIndex = (logicalIndex + delta + baseLen) % baseLen;

      // Move one physical card along the track (clones + real)
      const target = index + delta;
      animateTo(target);
    }

    // ---- Drag / swipe (ignore when starting on nav OR interactive elements) ----
    let startX = 0,
      currentX = 0,
      dragging = false,
      startedOnNav = false,
      startedOnInteractive = false;

    const isInteractive = (el) =>
      !!el.closest('a, button, input, textarea, select, label, .ps-btn');

    viewport.addEventListener('pointerdown', (e) => {
      if (!baseLen) return;
      startedOnNav = !!e.target.closest('.ps-nav');
      startedOnInteractive = isInteractive(e.target);
      if (startedOnNav || startedOnInteractive) return; // let clicks work normally

      dragging = true;
      startX = currentX = e.clientX;
      track.style.transition = 'none';
      isAnimating = false;
      root.classList.remove('ps--scrolling');
      viewport.setPointerCapture(e.pointerId);
    });

    viewport.addEventListener('pointermove', (e) => {
      if (!dragging || startedOnNav || startedOnInteractive) return;
      currentX = e.clientX;
      const dx = currentX - startX;

      const maxIdx = maxIndexFor();
      const minOffset = -maxIdx * colW;
      let offset = -index * colW + dx;

      if (offset > 0) offset = 0;
      if (offset < minOffset) offset = minOffset;

      track.style.transform = 'translateX(' + offset + 'px)';
    });

    function endDrag() {
      if (startedOnNav || startedOnInteractive) {
        startedOnNav = false;
        startedOnInteractive = false;
        return;
      }
      if (!dragging) return;
      dragging = false;
      track.style.transition = '';

      const dx = currentX - startX;
      const thresh = colW / 4;

      if (dx > thresh) go(-1);
      else if (dx < -thresh) go(1);
      else animateTo(index);
    }

    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    viewport.addEventListener('pointerleave', endDrag);

    // Click nav
    prev &&
      prev.addEventListener('click', (e) => {
        e.preventDefault();
        go(-1);
      });
    next &&
      next.addEventListener('click', (e) => {
        e.preventDefault();
        go(+1);
      });

    // Handle the invisible jump when moving onto clones
track.addEventListener('transitionend', (e) => {
  if (e.target !== track || e.propertyName !== 'transform') return;
  if (!baseLen) return;

  // NOTE: isAnimating now clears earlier via timeout.
  // This handler now ONLY handles loop jumps.

  const totalReal = baseLen;

  // Handle clone jump for infinite loop
  if (index < cloneCount) {
    index += totalReal;
    instantTo(index);
  } else if (index >= cloneCount + totalReal) {
    index -= totalReal;
    instantTo(index);
  }
});


    // Resize
    const ro = new ResizeObserver(layout);
    ro.observe(viewport);

    layout(); // initial
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(SEL).forEach(setupSection);
  });
})();
